package diana.soleil.design.iraniancanadienbazzar.feature.dashboard

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.common.Formatters
import diana.soleil.design.iraniancanadienbazzar.core.common.DataResult
import diana.soleil.design.iraniancanadienbazzar.core.common.ShareService
import diana.soleil.design.iraniancanadienbazzar.core.data.BusinessRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.FeatureFlags
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import androidx.compose.ui.platform.LocalUriHandler
import diana.soleil.design.iraniancanadienbazzar.core.model.PromotionPlan
import diana.soleil.design.iraniancanadienbazzar.core.model.formatPriceCents
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppConfirmDialog
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SettingsToggleRow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatusBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.tourAnchorInView
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.model.BusinessAttributeRegistry
import diana.soleil.design.iraniancanadienbazzar.core.model.BusinessStatus
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_add_listing
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_error
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_retry
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_channel
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_manage_orders
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_manage_products
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_attrs_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_edit_listing_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_help_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_next
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_done
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_skip
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_edit_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_edit_body
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_reviews_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_reviews_body
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_products_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_products_body
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_channel_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_channel_body
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_analytics_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_analytics_body
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_qr_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_qr_body
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_deals_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_tour_deals_body
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_privacy_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_privacy_hidden_desc
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_privacy_hidden_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_privacy_hide_address_desc
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_privacy_hide_address_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_privacy_save
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_delete_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_delete_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_delete_message
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_delete_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_delete_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_delete_failed
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_promote_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_promote_needs_metro
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_promote_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_promote_subtitle
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_promote_failed
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_plan_city_7d
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_plan_city_30d
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_plan_top_30d
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_headline_label
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_days_chip
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_create
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_ends_days
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_ended
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_deals_delete_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_privacy_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_attrs_hint
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_attrs_save
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_attrs_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_qr_button
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_qr_hint
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_qr_share
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_qr_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_qr_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_rating_count
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_manage_reviews
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_section_listings
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_stat_listings
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_stat_views
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_stat_leads
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_stat_pending
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_stat_rating
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_stat_reviews
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_status_approved
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_status_pending
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_status_rejected
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_status_suspended
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_title
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_view_analytics
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_view_listing
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.resources.dash_welcome
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.runtime.rememberCoroutineScope
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import io.github.alexzhirkevich.qrose.rememberQrCodePainter
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import diana.soleil.design.iraniancanadienbazzar.core.data.DealsRepository
import diana.soleil.design.iraniancanadienbazzar.core.model.Deal
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.core.model.LocalizedText
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf
import kotlin.time.Clock
import androidx.compose.runtime.collectAsState
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/** Stateful entry for the owner dashboard (overview + My Listings merged — see screen kdoc). */
@Composable
fun DashboardRoute(
    onBack: () -> Unit,
    onAddBusiness: () -> Unit,
    onOpenBusiness: (businessId: String) -> Unit,
    onManageReviews: (businessId: String) -> Unit,
    onManageProducts: (businessId: String) -> Unit,
    onManageOrders: (businessId: String) -> Unit,
    onAnalytics: (businessId: String) -> Unit,
    onOpenChannel: (businessId: String) -> Unit = {},
    onEditListing: (businessId: String) -> Unit = {},
    modifier: Modifier = Modifier,
    viewModel: DashboardViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val shareConfig = koinInject<ShareConfig>()
    val shareService = koinInject<ShareService>()
    val businessRepository = koinInject<BusinessRepository>()
    val dealsRepository = koinInject<DealsRepository>()
    val features by koinInject<FeatureFlags>().available.collectAsState()
    val preferences = koinInject<diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences>()
    DashboardScreen(
        state = state,
        startTour = preferences.ownerTourRequested,
        onTourStarted = { preferences.ownerTourRequested = false },
        onBack = onBack,
        onAddBusiness = onAddBusiness,
        onOpenBusiness = onOpenBusiness,
        onManageReviews = onManageReviews,
        onManageProducts = onManageProducts,
        onManageOrders = onManageOrders,
        onAnalytics = onAnalytics,
        onOpenChannel = onOpenChannel,
        onEditListing = onEditListing,
        businessLink = { id -> shareConfig.businessLink(id) },
        onShareLink = { link -> shareService.share(link) },
        onSaveAttributes = { id, attrs -> businessRepository.updateBusinessAttributes(id, attrs) is DataResult.Success },
        onSavePrivacy = { id, hideAddr, hidden ->
            businessRepository.updateBusinessPrivacy(id, hideAddr, hidden) is DataResult.Success
        },
        onDeleteBusiness = { id -> businessRepository.deleteBusiness(id) is DataResult.Success },
        onCreatePromotionCheckout = { id, planId ->
            (businessRepository.createPromotionCheckout(id, planId) as? DataResult.Success)?.data
        },
        dealsFor = { id -> dealsRepository.observeDealsForBusiness(id) },
        onCreateDeal = { id, name, title, days ->
            dealsRepository.createDeal(
                id, name, LocalizedText.of(title), null,
                Clock.System.now().toEpochMilliseconds() + days * 86_400_000L,
            ) is DataResult.Success
        },
        onDeleteDeal = { dealId -> dealsRepository.deleteDeal(dealId) is DataResult.Success },
        paymentsEnabled = features.payments,
        onRetry = viewModel::retry,
        modifier = modifier,
    )
}

/**
 * Business dashboard (Stitch `f0c09108` overview + `64546172` My Listings, merged into one screen for
 * the Phase-2 slice — most owners have one listing, so a separate listings page adds a hop for no
 * benefit; split when multi-listing owners are real). **Honest metrics only**: views/leads are the
 * server-maintained `metrics/counters` sums (recordListingMetric Function is the sole writer) — never
 * fabricated. Tokens + string resources only.
 */
@Composable
fun DashboardScreen(
    state: DashboardUiState,
    onBack: () -> Unit,
    onAddBusiness: () -> Unit,
    onOpenBusiness: (businessId: String) -> Unit,
    onManageReviews: (businessId: String) -> Unit,
    onManageProducts: (businessId: String) -> Unit,
    onManageOrders: (businessId: String) -> Unit,
    onAnalytics: (businessId: String) -> Unit,
    onOpenChannel: (businessId: String) -> Unit = {},
    /** Full owner editor: photos, description, contact, hours, and name/category/address requests. */
    onEditListing: (businessId: String) -> Unit = {},
    businessLink: (businessId: String) -> String,
    onShareLink: (String) -> Unit,
    onSaveAttributes: suspend (businessId: String, attributes: List<String>) -> Boolean,
    onSavePrivacy: suspend (businessId: String, hideExactAddress: Boolean, ownerHidden: Boolean) -> Boolean,
    onDeleteBusiness: suspend (businessId: String) -> Boolean = { false },
    /** Returns the Stripe hosted-Checkout URL for a promotion purchase, or null on failure. */
    onCreatePromotionCheckout: suspend (businessId: String, planId: String) -> String? = { _, _ -> null },
    dealsFor: (businessId: String) -> Flow<DataResult<List<Deal>>> = { flowOf(DataResult.Success(emptyList())) },
    onCreateDeal: suspend (businessId: String, businessName: String, title: String, days: Int) -> Boolean = { _, _, _, _ -> false },
    onDeleteDeal: suspend (dealId: String) -> Boolean = { false },
    /**
     * `feature_payments_enabled` (default FALSE). Hides the Stripe "Promote listing" action; Stripe
     * is test-mode only, so on an env without prod keys Checkout dead-ends a real merchant.
     */
    paymentsEnabled: Boolean = false,
    onRetry: () -> Unit,
    modifier: Modifier = Modifier,
    /** Run the owner spotlight tour once the listings load (set by the owner welcome's "Show me around"). */
    startTour: Boolean = false,
    onTourStarted: () -> Unit = {},
) {
    val listState = androidx.compose.foundation.lazy.rememberLazyListState()
    val tour = diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.rememberTourState()
    val tourScope = rememberCoroutineScope()
    // The tour's anchors live on the LAST listing card: scrolling to the list's end guarantees that card
    // is composed (a lazy list only composes what is near the screen), then each step scrolls its button in.
    fun runTour() {
        tourScope.launch {
            val last = listState.layoutInfo.totalItemsCount - 1
            if (last >= 0) listState.scrollToItem(last)
            kotlinx.coroutines.delay(DASH_TOUR_SETTLE_MS)
            tour.start()
        }
    }
    androidx.compose.runtime.LaunchedEffect(startTour, state.businesses.isNotEmpty()) {
        if (startTour && state.businesses.isNotEmpty()) {
            onTourStarted()
            runTour()
        }
    }
    // The listing whose print-ready QR sheet is open (null = closed).
    var qrBusiness by remember { mutableStateOf<Business?>(null) }
    // The listing whose privacy editor is open (null = closed).
    var privacyBusiness by remember { mutableStateOf<Business?>(null) }
    var dealsBusiness by remember { mutableStateOf<Business?>(null) }
    // The listing whose details/amenities editor is open (null = closed).
    var attrBusiness by remember { mutableStateOf<Business?>(null) }
    Box(modifier = modifier.background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidth).fillMaxHeight().statusBarsPadding().navigationBarsPadding()) {
        LazyColumn(
            state = listState,
            contentPadding = PaddingValues(
                start = AppTheme.spacing.lg,
                end = AppTheme.spacing.lg,
                top = AppTheme.spacing.md,
                bottom = AppTheme.spacing.xl,
            ),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            item {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    AppIconButton(
                        iconName = "arrow_back",
                        contentDescription = stringResource(Res.string.dash_back_a11y),
                        onClick = onBack,
                        tint = AppTheme.colors.onSurface,
                    )
                    if (state.businesses.isNotEmpty()) {
                        AppIconButton(
                            iconName = "help",
                            contentDescription = stringResource(Res.string.dash_tour_help_a11y),
                            onClick = ::runTour,
                            tint = AppTheme.colors.onSurface,
                        )
                    }
                }
            }
            item {
                Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                    Text(
                        text = stringResource(Res.string.dash_title),
                        style = AppTheme.typography.headlineLg,
                        color = AppTheme.colors.onSurface,
                    )
                    Text(
                        text = stringResource(Res.string.dash_welcome),
                        style = AppTheme.typography.bodyMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
            }

            if (state.loading) {
                item { LoadingState() }
                return@LazyColumn
            }
            if (state.error) {
                item {
                    ErrorState(
                        message = stringResource(Res.string.dash_error),
                        onRetry = onRetry,
                        retryLabel = stringResource(Res.string.dash_retry),
                    )
                }
                return@LazyColumn
            }
            if (state.businesses.isEmpty()) {
                item {
                    EmptyState(
                        title = stringResource(Res.string.dash_empty_title),
                        description = stringResource(Res.string.dash_empty_desc),
                    )
                }
                item {
                    AppButton(
                        text = stringResource(Res.string.dash_add_listing),
                        onClick = onAddBusiness,
                        modifier = Modifier.fillMaxWidth(),
                        leadingIcon = "add",
                    )
                }
                return@LazyColumn
            }

            item {
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                    StatCard(
                        value = state.listingCount.toString(),
                        label = stringResource(Res.string.dash_stat_listings),
                        icon = "storefront",
                        modifier = Modifier.weight(1f),
                    )
                    StatCard(
                        value = state.totalReviews.toString(),
                        label = stringResource(Res.string.dash_stat_reviews),
                        icon = "reviews",
                        modifier = Modifier.weight(1f),
                    )
                    StatCard(
                        value = if (state.totalReviews == 0) "—" else Formatters.rating(state.averageRating.toFloat()),
                        label = stringResource(Res.string.dash_stat_rating),
                        icon = "star",
                        modifier = Modifier.weight(1f),
                    )
                }
            }
            item {
                Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                    StatCard(
                        value = state.counters?.views?.toString() ?: "—",
                        label = stringResource(Res.string.dash_stat_views),
                        icon = "visibility",
                        modifier = Modifier.weight(1f),
                    )
                    StatCard(
                        value = state.counters?.leads?.toString() ?: "—",
                        label = stringResource(Res.string.dash_stat_leads),
                        icon = "call",
                        modifier = Modifier.weight(1f),
                    )
                }
            }
            if (state.pendingCount > 0) {
                item {
                    Text(
                        text = stringResource(Res.string.dash_stat_pending, state.pendingCount),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
            }

            item {
                SectionHeader(
                    title = stringResource(Res.string.dash_section_listings),
                    actionLabel = stringResource(Res.string.dash_add_listing),
                    onAction = onAddBusiness,
                )
            }
            items(count = state.businesses.size, key = { state.businesses[it].id }) { index ->
                val business = state.businesses[index]
                OwnedListingCard(
                    business = business,
                    tour = tour.takeIf { index == state.businesses.lastIndex },
                    onOpen = { onOpenBusiness(business.id) },
                    onManageReviews = { onManageReviews(business.id) },
                    onManageProducts = { onManageProducts(business.id) },
                    onManageOrders = { onManageOrders(business.id) },
                    onAnalytics = { onAnalytics(business.id) },
                    onOpenChannel = { onOpenChannel(business.id) },
                    onEditListing = { onEditListing(business.id) },
                    onShowQr = { qrBusiness = business },
                    onEditDetails = { attrBusiness = business },
                    onEditPrivacy = { privacyBusiness = business },
                    onEditDeals = { dealsBusiness = business },
                    onDelete = { onDeleteBusiness(business.id) },
                    onPromote = { planId -> onCreatePromotionCheckout(business.id, planId) },
                    paymentsEnabled = paymentsEnabled,
                )
            }
        }
        diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FeatureTourOverlay(
            state = tour,
            steps = listOf(
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep(DASH_TOUR_EDIT, stringResource(Res.string.dash_tour_edit_title), stringResource(Res.string.dash_tour_edit_body)),
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep(DASH_TOUR_REVIEWS, stringResource(Res.string.dash_tour_reviews_title), stringResource(Res.string.dash_tour_reviews_body)),
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep(DASH_TOUR_PRODUCTS, stringResource(Res.string.dash_tour_products_title), stringResource(Res.string.dash_tour_products_body)),
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep(DASH_TOUR_CHANNEL, stringResource(Res.string.dash_tour_channel_title), stringResource(Res.string.dash_tour_channel_body)),
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep(DASH_TOUR_ANALYTICS, stringResource(Res.string.dash_tour_analytics_title), stringResource(Res.string.dash_tour_analytics_body)),
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep(DASH_TOUR_QR, stringResource(Res.string.dash_tour_qr_title), stringResource(Res.string.dash_tour_qr_body)),
                diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourStep(DASH_TOUR_DEALS, stringResource(Res.string.dash_tour_deals_title), stringResource(Res.string.dash_tour_deals_body)),
            ),
            nextLabel = stringResource(Res.string.dash_tour_next),
            doneLabel = stringResource(Res.string.dash_tour_done),
            skipLabel = stringResource(Res.string.dash_tour_skip),
            onFinished = {},
        )
    }

    // Print-and-display QR: encodes the SAME universal link the share sheet sends
    // (mahaleh.ca/b/{id}) — scanning opens the installed app via App Links, else the web page.
    val qrTarget = qrBusiness
    if (qrTarget != null) {
        AppBottomSheet(
            onDismissRequest = { qrBusiness = null },
            title = stringResource(Res.string.dash_qr_title),
        ) {
            val link = businessLink(qrTarget.id)
            Column(
                modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.lg),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                Text(
                    text = qrTarget.name,
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                    textAlign = TextAlign.Center,
                )
                Box(
                    modifier = Modifier
                        .background(AppTheme.colors.surface, AppTheme.shapes.card)
                        .padding(AppTheme.spacing.md),
                ) {
                    Image(
                        painter = rememberQrCodePainter(link),
                        contentDescription = stringResource(Res.string.dash_qr_a11y),
                        modifier = Modifier.size(AppTheme.sizes.qrCode),
                    )
                }
                Text(
                    text = link,
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                )
                Text(
                    text = stringResource(Res.string.dash_qr_hint),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                )
                AppButton(
                    text = stringResource(Res.string.dash_qr_share),
                    onClick = { onShareLink(link) },
                    modifier = Modifier.fillMaxWidth(),
                    leadingIcon = "share",
                )
            }
        }
    }

    // Details & amenities editor: the category-scoped structured facts (BusinessAttributeRegistry).
    // Local draft; Save persists via the owner-update rules path and closes on success.
    val attrTarget = attrBusiness
    if (attrTarget != null) {
        AttributesEditorSheet(
            business = attrTarget,
            onSave = onSaveAttributes,
            onDismiss = { attrBusiness = null },
        )
    }
    val dealsTarget = dealsBusiness
    if (dealsTarget != null) {
        DealsEditorSheet(
            business = dealsTarget,
            deals = dealsFor(dealsTarget.id),
            onCreate = onCreateDeal,
            onDelete = onDeleteDeal,
            onDismiss = { dealsBusiness = null },
        )
    }
    val privacyTarget = privacyBusiness
    if (privacyTarget != null) {
        PrivacyEditorSheet(
            business = privacyTarget,
            onSave = onSavePrivacy,
            onDismiss = { privacyBusiness = null },
        )
    }
}

/**
 * Owner privacy controls (Canadian-privacy guardrails): hide the exact street address for a
 * home-based listing, and hide the whole listing from public discovery. Persists via the
 * owner-update rules path; closes on success.
 */
@Composable
private fun PrivacyEditorSheet(
    business: Business,
    onSave: suspend (businessId: String, hideExactAddress: Boolean, ownerHidden: Boolean) -> Boolean,
    onDismiss: () -> Unit,
) {
    var hideAddress by remember(business.id) { mutableStateOf(business.hideExactAddress) }
    var hidden by remember(business.id) { mutableStateOf(business.ownerHidden) }
    var saving by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    AppBottomSheet(
        onDismissRequest = onDismiss,
        title = stringResource(Res.string.dash_privacy_title),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            SettingsToggleRow(
                iconName = "location_off",
                title = stringResource(Res.string.dash_privacy_hide_address_title),
                subtitle = stringResource(Res.string.dash_privacy_hide_address_desc),
                checked = hideAddress,
                onCheckedChange = { hideAddress = it },
            )
            SettingsToggleRow(
                iconName = "visibility_off",
                title = stringResource(Res.string.dash_privacy_hidden_title),
                subtitle = stringResource(Res.string.dash_privacy_hidden_desc),
                checked = hidden,
                onCheckedChange = { hidden = it },
            )
            AppButton(
                text = stringResource(Res.string.dash_privacy_save),
                onClick = {
                    if (!saving) {
                        saving = true
                        scope.launch {
                            val ok = onSave(business.id, hideAddress, hidden)
                            saving = false
                            if (ok) onDismiss()
                        }
                    }
                },
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = "check",
                enabled = !saving,
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun AttributesEditorSheet(
    business: Business,
    onSave: suspend (businessId: String, attributes: List<String>) -> Boolean,
    onDismiss: () -> Unit,
) {
    // Only this category's answers: a listing whose category changed may still carry the old ones.
    var draft by remember(business.id) {
        mutableStateOf(BusinessAttributeRegistry.keepValidFor(business.categoryId, business.attributes))
    }
    var saving by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    AppBottomSheet(
        onDismissRequest = onDismiss,
        title = stringResource(Res.string.dash_attrs_title),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            Text(
                text = stringResource(Res.string.dash_attrs_hint),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                BusinessAttributeRegistry.forCategory(business.categoryId).forEach { def ->
                    AppChip(
                        label = def.label.resolve(AppTheme.language),
                        selected = def.key in draft,
                        onClick = { draft = if (def.key in draft) draft - def.key else draft + def.key },
                    )
                }
            }
            AppButton(
                text = stringResource(Res.string.dash_attrs_save),
                onClick = {
                    if (!saving) {
                        saving = true
                        scope.launch {
                            val ok = onSave(business.id, draft.toList())
                            saving = false
                            if (ok) onDismiss()
                        }
                    }
                },
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = "check",
                enabled = !saving,
            )
        }
    }
}

@Composable
private fun StatCard(value: String, label: String, icon: String, modifier: Modifier = Modifier) {
    AppCard(modifier = modifier) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.md),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        ) {
            AppIcon(name = icon, size = AppTheme.sizes.iconMd, tint = AppTheme.colors.primary)
            Text(text = value, style = AppTheme.typography.headlineMd, color = AppTheme.colors.onSurface)
            Text(text = label, style = AppTheme.typography.labelSm, color = AppTheme.colors.onSurfaceVariant)
        }
    }
}

@Composable
private fun OwnedListingCard(
    business: Business,
    /** Non-null on the one card that carries the owner tour's anchors. */
    tour: diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.TourState? = null,
    onOpen: () -> Unit,
    onManageReviews: () -> Unit,
    onManageProducts: () -> Unit,
    onManageOrders: () -> Unit,
    onAnalytics: () -> Unit,
    onOpenChannel: () -> Unit,
    onEditListing: () -> Unit,
    onShowQr: () -> Unit,
    onEditDetails: () -> Unit,
    onEditPrivacy: () -> Unit,
    onEditDeals: () -> Unit,
    onDelete: suspend () -> Boolean,
    onPromote: suspend (planId: String) -> String?,
    /** `feature_payments_enabled` — hides the Stripe "Promote listing" action when off. */
    paymentsEnabled: Boolean,
) {
    val scope = rememberCoroutineScope()
    val uriHandler = LocalUriHandler.current
    var confirmDelete by remember { mutableStateOf(false) }
    var deleting by remember { mutableStateOf(false) }
    var deleteFailed by remember { mutableStateOf(false) }
    var showPromote by remember { mutableStateOf(false) }
    var promotingPlan by remember { mutableStateOf<String?>(null) }
    var promoteFailed by remember { mutableStateOf(false) }
    fun Modifier.tourKey(key: String): Modifier =
        if (tour != null) tourAnchorInView(tour, key) else this
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = business.name,
                    style = AppTheme.typography.bodyLg,
                    color = AppTheme.colors.onSurface,
                )
                StatusBadge(
                    label = stringResource(
                        when (business.status) {
                            BusinessStatus.Approved -> Res.string.dash_status_approved
                            BusinessStatus.Pending -> Res.string.dash_status_pending
                            BusinessStatus.Rejected -> Res.string.dash_status_rejected
                            BusinessStatus.Suspended -> Res.string.dash_status_suspended
                        },
                    ),
                )
            }
            Text(
                text = stringResource(Res.string.dash_rating_count, Formatters.rating(business.rating.toFloat()), business.reviewCount),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
            )
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                AppButton(
                    text = stringResource(Res.string.dash_view_listing),
                    onClick = onOpen,
                    modifier = Modifier.weight(1f),
                    variant = AppButtonVariant.Secondary,
                )
                AppButton(
                    text = stringResource(Res.string.dash_manage_reviews),
                    onClick = onManageReviews,
                    modifier = Modifier.weight(1f).tourKey(DASH_TOUR_REVIEWS),
                )
            }
            // The one place an owner changes what their listing says and shows (owner report 2026-09-14).
            AppButton(
                text = stringResource(Res.string.dash_edit_listing_button),
                onClick = onEditListing,
                modifier = Modifier.fillMaxWidth().tourKey(DASH_TOUR_EDIT),
                leadingIcon = "edit",
            )
            AppButton(
                text = stringResource(Res.string.dash_manage_products),
                onClick = onManageProducts,
                modifier = Modifier.fillMaxWidth().tourKey(DASH_TOUR_PRODUCTS),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "sell",
            )
            AppButton(
                text = stringResource(Res.string.dash_manage_orders),
                onClick = onManageOrders,
                modifier = Modifier.fillMaxWidth(),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "receipt_long",
            )
            AppButton(
                text = stringResource(Res.string.dash_channel),
                onClick = onOpenChannel,
                modifier = Modifier.fillMaxWidth().tourKey(DASH_TOUR_CHANNEL),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "campaign",
            )
            AppButton(
                text = stringResource(Res.string.dash_view_analytics),
                onClick = onAnalytics,
                modifier = Modifier.fillMaxWidth().tourKey(DASH_TOUR_ANALYTICS),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "analytics",
            )
            AppButton(
                text = stringResource(Res.string.dash_qr_button),
                onClick = onShowQr,
                modifier = Modifier.fillMaxWidth().tourKey(DASH_TOUR_QR),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "qr_code_2",
            )
            AppButton(
                text = stringResource(Res.string.dash_attrs_button),
                onClick = onEditDetails,
                modifier = Modifier.fillMaxWidth(),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "tune",
            )
            AppButton(
                text = stringResource(Res.string.dash_privacy_button),
                onClick = onEditPrivacy,
                modifier = Modifier.fillMaxWidth(),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "shield",
            )
            AppButton(
                text = stringResource(Res.string.dash_deals_button),
                onClick = onEditDeals,
                modifier = Modifier.fillMaxWidth().tourKey(DASH_TOUR_DEALS),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "sell",
            )
            // Revenue action — solid Primary so it stands out from the neutral management buttons.
            // Hidden entirely unless `feature_payments_enabled` is on: Stripe is test-mode only, so
            // on an env without prod keys this Checkout dead-ends a real merchant's card. Absent
            // beats "coming soon" — no fake paywalls (docs/ROADMAP.md).
            // Also gated to Approved AND a resolved metro: featured placement is metro-scoped, so a
            // listing with no metroId would pay but never appear in the carousel — don't sell that.
            if (paymentsEnabled) {
                AppButton(
                    text = stringResource(Res.string.dash_promote_button),
                    onClick = { promoteFailed = false; showPromote = true },
                    modifier = Modifier.fillMaxWidth(),
                    leadingIcon = "rocket_launch",
                    enabled = business.status == BusinessStatus.Approved && business.metroId != null,
                )
                // Explain the disabled state instead of a dead control (the metro is derived from
                // the listing's city; an unrecognized city leaves it un-promotable).
                if (business.status == BusinessStatus.Approved && business.metroId == null) {
                    Text(
                        text = stringResource(Res.string.dash_promote_needs_metro),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
            }
            if (deleteFailed) {
                Text(
                    text = stringResource(Res.string.dash_delete_failed),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.error,
                )
            }
            AppButton(
                text = stringResource(Res.string.dash_delete_button),
                onClick = { confirmDelete = true },
                modifier = Modifier.fillMaxWidth(),
                variant = AppButtonVariant.Destructive,
                leadingIcon = "delete",
                loading = deleting,
            )
        }
    }

    if (confirmDelete) {
        AppConfirmDialog(
            title = stringResource(Res.string.dash_delete_title),
            message = stringResource(Res.string.dash_delete_message, business.name),
            confirmLabel = stringResource(Res.string.dash_delete_confirm),
            cancelLabel = stringResource(Res.string.dash_delete_cancel),
            destructive = true,
            onConfirm = {
                confirmDelete = false
                deleteFailed = false
                deleting = true
                scope.launch {
                    val ok = onDelete()
                    deleting = false
                    // On success the owned-listings stream drops this card; only surface failures.
                    if (!ok) deleteFailed = true
                }
            },
            onDismiss = { confirmDelete = false },
        )
    }

    if (showPromote) {
        AppBottomSheet(
            onDismissRequest = { if (promotingPlan == null) showPromote = false },
            title = stringResource(Res.string.dash_promote_title),
        ) {
            Column(
                modifier = Modifier.fillMaxWidth().padding(horizontal = AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                Text(
                    text = stringResource(Res.string.dash_promote_subtitle),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
                if (promoteFailed) {
                    Text(
                        text = stringResource(Res.string.dash_promote_failed),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.error,
                    )
                }
                PromotionPlan.all.forEach { plan ->
                    AppButton(
                        text = "${promotionPlanLabel(plan)} · ${AppTheme.language.formatPriceCents(plan.priceCents)}",
                        onClick = {
                            promoteFailed = false
                            promotingPlan = plan.id
                            scope.launch {
                                val url = onPromote(plan.id)
                                promotingPlan = null
                                if (url != null) {
                                    showPromote = false
                                    // Stripe hosted Checkout — after payment the webhook flips the boost.
                                    uriHandler.openUri(url)
                                } else {
                                    promoteFailed = true
                                }
                            }
                        },
                        modifier = Modifier.fillMaxWidth(),
                        variant = AppButtonVariant.Secondary,
                        loading = promotingPlan == plan.id,
                        enabled = promotingPlan == null,
                    )
                }
            }
        }
    }
}

/** Localized name for a promotion plan (price is formatted separately by the caller). */
@Composable
private fun promotionPlanLabel(plan: PromotionPlan): String = stringResource(
    when (plan) {
        PromotionPlan.CityWeek -> Res.string.dash_plan_city_7d
        PromotionPlan.CityMonth -> Res.string.dash_plan_city_30d
        PromotionPlan.TopMonth -> Res.string.dash_plan_top_30d
    },
)

/**
 * Owner deals manager: live list of the business's promotions (with delete) + a composer (headline +
 * duration chips). Free while the feature bootstraps; deals auto-expire at endsAt. Rules restrict
 * writes to the business owner; moderators can hide reported deals.
 */
@Composable
private fun DealsEditorSheet(
    business: Business,
    deals: Flow<DataResult<List<Deal>>>,
    onCreate: suspend (businessId: String, businessName: String, title: String, days: Int) -> Boolean,
    onDelete: suspend (dealId: String) -> Boolean,
    onDismiss: () -> Unit,
) {
    val dealsResult by deals.collectAsState(initial = DataResult.Success(emptyList()))
    val existing = (dealsResult as? DataResult.Success)?.data ?: emptyList()
    var title by remember(business.id) { mutableStateOf("") }
    var days by remember(business.id) { mutableStateOf(7) }
    var saving by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    val nowMillis = Clock.System.now().toEpochMilliseconds()

    AppBottomSheet(
        onDismissRequest = onDismiss,
        title = stringResource(Res.string.dash_deals_title),
    ) {
        if (existing.isNotEmpty()) {
            existing.forEach { deal ->
                Row(
                    modifier = Modifier.fillMaxWidth().padding(vertical = AppTheme.spacing.xs),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    Column(modifier = Modifier.weight(1f)) {
                        Text(
                            text = deal.title.resolve(Language.Default),
                            style = AppTheme.typography.bodyMd,
                            color = AppTheme.colors.onSurface,
                        )
                        val daysLeft = ((deal.endsAtMillis - nowMillis) / 86_400_000L).toInt()
                        Text(
                            text = if (deal.isActive(nowMillis)) {
                                stringResource(Res.string.dash_deals_ends_days, daysLeft.coerceAtLeast(0) + 1)
                            } else {
                                stringResource(Res.string.dash_deals_ended)
                            },
                            style = AppTheme.typography.labelSm,
                            color = AppTheme.colors.onSurfaceVariant,
                        )
                    }
                    AppIconButton(
                        iconName = "delete",
                        contentDescription = stringResource(Res.string.dash_deals_delete_a11y),
                        onClick = { scope.launch { onDelete(deal.id) } },
                    )
                }
            }
        }
        AppTextField(
            value = title,
            onValueChange = { title = it },
            label = stringResource(Res.string.dash_deals_headline_label),
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.md),
        )
        Row(
            modifier = Modifier.padding(top = AppTheme.spacing.sm),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            listOf(7, 14, 30).forEach { option ->
                AppChip(
                    label = stringResource(Res.string.dash_deals_days_chip, option),
                    selected = days == option,
                    onClick = { days = option },
                )
            }
        }
        AppButton(
            text = stringResource(Res.string.dash_deals_create),
            onClick = {
                if (title.isBlank() || saving) return@AppButton
                scope.launch {
                    saving = true
                    if (onCreate(business.id, business.name, title.trim(), days)) title = ""
                    saving = false
                }
            },
            enabled = title.isNotBlank() && !saving,
            loading = saving,
            leadingIcon = "sell",
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.lg),
        )
    }
}

private const val DASH_TOUR_SETTLE_MS = 450L
private const val DASH_TOUR_EDIT = "dash_tour_edit"
private const val DASH_TOUR_REVIEWS = "dash_tour_reviews"
private const val DASH_TOUR_PRODUCTS = "dash_tour_products"
private const val DASH_TOUR_CHANNEL = "dash_tour_channel"
private const val DASH_TOUR_ANALYTICS = "dash_tour_analytics"
private const val DASH_TOUR_QR = "dash_tour_qr"
private const val DASH_TOUR_DEALS = "dash_tour_deals"
